import axios from 'axios'

const getDealers = async () => {
  try {
    const response = await axios.get(`${process.env.NEXT_PUBLIC_API}/dealers`)
    return response.data
  } catch (error) {
    return false
  }
}
export default getDealers
